let _progressCallback,
    _finishCallback,
    _notFinishedCallback,
    _axiosInstance,
    _guid, _file, _url;

let inProgress = false,
    paused = false,
    isCanceled = false,
    chunkNumber, totalSize, totalChunks, begin, end;

const chunkSize = 1048576;

const sendChunk = () => {
    end = begin + chunkSize;

    if (totalSize - end < 0) {
        end = totalSize;
    }

    let chunk = _file.slice(begin, end);

    const formData: FormData = new FormData();
    formData.append('chunk', chunk);
    formData.append('chunkNumber', chunkNumber);
    formData.append('chunkSize', chunkSize);
    formData.append('totalSize', totalSize);
    formData.append('identifier', _guid);
    formData.append('fileName', _file.name);
    formData.append('totalChunks', totalChunks);

    _axiosInstance.post(_url, formData)
        .then(() => {
            if (end < totalSize) {
                if (isCanceled) {
                    if (_finishCallback) _finishCallback(isCanceled);
                    isCanceled = false;
                }
                if (!inProgress) return;
                if (paused) return;
                if (_progressCallback) _progressCallback(chunkNumber / totalChunks);

                begin += chunkSize;
                chunkNumber++;
                sendChunk();
            } else {
                if (_finishCallback) _finishCallback(isCanceled);
                inProgress = false;
                _guid = null;
            }
        })
        .catch((error) => {
            paused = true;
            if (_notFinishedCallback) _notFinishedCallback(error.message);
        });
}

export const start = (url, file, guid, progressCallback, finishCallback, notFinishedCallback, axiosInstance) => {
    if (inProgress) return;

    inProgress = true;
    isCanceled = false;
    _progressCallback = progressCallback;
    _finishCallback = finishCallback;
    _notFinishedCallback = notFinishedCallback;
    _axiosInstance = axiosInstance;
    _url = url;
    _file = file;
    _guid = guid;

    // 2. send file
    begin = 0;
    end = 0;
    chunkNumber = 1;
    totalSize = file.size;
    totalChunks = Math.ceil(totalSize / chunkSize);

    sendChunk();
}

export const cancel = () => {
    inProgress = false; 
    paused = false;
    isCanceled = true;
    if (_guid) {
        _axiosInstance.post(`/upload/cancel/${_guid}`);
    }
}

export const resume = () => {
    paused = false;
    sendChunk();
}

export const pause = () => {
    paused = true;
}


// WEBPACK FOOTER //
// ./src/containers/content/grid/uploadPanel/chunkUpload.js